<template>
    <div class="flex flex-col items-start justify-end gap-2 border-b border-gray-200 h-[80px]">
        <label :for="id" class="font-extralight ">
            {{ label }}
            <span v-if="required" class="text-red-500">*</span>
        </label>

        <CurrencyInput v-if="type === 'currency'" :id="id" :options="options" class="p-1 outline-none focus:ring-0 w-full" :value="modelValue" @input="updateValue" />
        <input v-bind="$attrs" v-else-if="mask" v-mask="mask" :id="id" :type="type" class="p-1 outline-none focus:ring-0 w-full" :value="modelValue" @input="updateValue" />
        <input v-bind="$attrs" v-else :id="id" :type="type" class="p-1 outline-none focus:ring-0 w-full" :value="modelValue" @input="updateValue" />

    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import CurrencyInput from './CurrencyInput'


const props = defineProps({
    label: {
        type: String,
        required: true
    },
    type: {
        type: String,
        default: 'text'
    },
    modelValue: {
        required: true
    },
    mask: {
        type: String,
        default: ''
    },
    options: {
        type: Object,
        default: () => ({})
    },
    required: {
        type: Boolean,
        default: false
    }
});

const id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

const emit = defineEmits(['update:modelValue']);

function updateValue(event) {
    if (props.type === 'currency') {
        console.log(event.target.value);
        emit('update:modelValue', parseFloat(event.target.value));
    } else {
        emit('update:modelValue', event.target.value);
    }
}
</script>


